import React from "react";
import { Member, MessageUserData } from "../../utils/types";
import { getMemberAvatarUrl } from "./utils";

interface Props {
  member: Member | MessageUserData | undefined;
  sizeInPx: number;
}

const MemberAvatarImg: React.FC<Props> = ({ member, sizeInPx }) => (
  <img
    className="h-10 w-10 rounded-full"
    src={getMemberAvatarUrl(member, sizeInPx)}
    onError={(e: any) => {
      e.target.onerror = null;
      e.target.src = getMemberAvatarUrl(member, sizeInPx, true);
    }}
    alt="user avatar"
  />
);

export default MemberAvatarImg;
